import { render, staticRenderFns } from "./BaseCreditsItem.vue?vue&type=template&id=7a73c15c&"
import script from "./BaseCreditsItem.vue?vue&type=script&lang=js&"
export * from "./BaseCreditsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports